export const industryOptions = [
    {
        category: "Entertainment / Leisure",
        options: [
            { id: 2, name: "Events" },
            { id: 5, name: "Golf Club" },
            { id: 1, name: "Leisure / Activity Centres / Recreation" },
            { id: 6, name: "Other Entertainment Services" },
            { id: 4, name: "Theatre / Cinema" },
            { id: 3, name: "Theme Park / Zoo / Aquarium" },
        ]
    },
    {
        category: "Healthcare / Medical",
        options: [
            { id: 20, name: "Assisted Living / Care Homes" },
            { id: 19, name: "Care Agency" },
            { id: 21, name: "Dental Practice" },
            { id: 22, name: "GP Surgery / Primary Care" },
            { id: 23, name: "Hospital / Hospital Department" },
            { id: 24, name: "Optical" },
            { id: 27, name: "Other Healthcare / Medical" },
            { id: 25, name: "Pharmacy" },
            { id: 26, name: "Veterinary / Animal Care" },
        ]
    },
    {
        category: "Hospitality / Catering",
        options: [
            { id: 7, name: "Bar / Club" },
            { id: 12, name: "Catering / Events" },
            { id: 14, name: "Deli / Bakery" },
            { id: 11, name: "Hotel / Resorts" },
            { id: 13, name: "Mobile" },
            { id: 15, name: "Other Hospitality" },
            { id: 10, name: "Pop-up" },
            { id: 9, name: "QSR / Fast Casual" },
            { id: 8, name: "Restaurant / Cafe" },
        ]
    },
    {
        category: "Professional Service / Public Service",
        options: [
            { id: 38, name: "Beauty / Salon / Massage" },
            { id: 31, name: "Call Centre" },
            { id: 32, name: "Cleaning Service" },
            { id: 37, name: "Communal Organisation" },
            { id: 41, name: "Councils / Public Authority" },
            { id: 34, name: "Crime / Police Services" },
            { id: 33, name: "Emergency Services" },
            { id: 36, name: "Non-profit / Volunteer / Charities" },
            { id: 43, name: "Other Professional Service" },
            { id: 39, name: "Pet Care / Kennels" },
            { id: 35, name: "Security Services" },
            { id: 42, name: "Transportation" },
            { id: 40, name: "University / Other Education" },
        ]
    },
    {
        category: "Retail",
        options: [
            { id: 17, name: "Online / Ecommerce Store" },
            { id: 18, name: "Other Retail" },
            { id: 16, name: "Retail Store" },
        ]
    },
    {
        category: "Technology / Software",
        options: [
            { id: 29, name: "IT" },
            { id: 30, name: "Other Software / Technology" },
            { id: 28, name: "SaaS" },
        ]
    },
    {
        category: "Other",
        options: [
            { id: 44, name: "Other" },
        ]
    },
];